import { QueryClient } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,      // 5 minutes
      gcTime: 1000 * 60 * 10,        // 10 minutes
      retry: (failureCount, error) => {
        const axiosError = error as AxiosError
        // Ne pas retry sur les 4xx (sauf 429 rate limit)
        if (axiosError?.response?.status && axiosError.response.status < 500 && axiosError.response.status !== 429) {
          return false
        }
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: false,
    },
  },
})
